import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Dashboard from './pages/Dashboard';
import Layout from './layout'; // Import the Layout component

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing page route - no layout */}
        <Route path="/" element={<Landing />} />
        <Route path="/landing" element={<Landing />} />

        {/* Dashboard route with layout */}
        <Route path="/dashboard" element={
          <Layout currentPageName="Dashboard">
            <Dashboard />
          </Layout>
        } />

        {/* Add more routes as needed */}
      </Routes>
    </Router>
  );
}

export default App;
